export default __webpack_public_path__ + "strongher-second-screens_small@2x.4afc89d5.png";